import React, { Fragment } from 'react';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { AddTaskTemplateBulk } from './add'
import { EditTaskTemplateBulk } from '../Pages/edit'




function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  
  
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
  }));
  

  export function TabPanelAddEdit({ }) {


    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleTabChange = (event, newValue) => {
      setValue(newValue);
    };


  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div>
        <div className={classes.root}>
          <AppBar position="static" color="#f44336">
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="simple tabs example"
            >
              <Tab label="Add" />
              <Tab label="Edit" />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>

            <AddTaskTemplateBulk 
            data={[]}
            edit ={false}
            />

          </TabPanel>
          <TabPanel value={value} index={1}>

            <EditTaskTemplateBulk 
            data={[]}
            edit ={false}
            />

          </TabPanel>
        </div>
      </div>
    </Fragment>
  );
  }